import * as React from 'react'
import { View } from 'react-native'
import styled from '@theme/styled-components'

import TextInput from '@components/textInput/TextInput'
import Choice from '@components/choice/Choice'
import Animators from '@components/root/Animators'

import useI18n from '@i18n/useI18n'

import sanitize from '@utils/Sanitizer'

interface Props {
  data: FamilleResponse[]
  onItemSelected: (item: string) => void
  selected?: string
}

const Activity = ({ data, onItemSelected, selected }: Props) => {
  const i18n = useI18n()

  const [search, setSearch] = React.useState('')

  const filtered = React.useMemo(
    () =>
      data
        .filter((p) => sanitize(p.libelle).includes(sanitize(search)))
        .sort((a, b) => a.libelle.localeCompare(b.libelle)),
    [data, search]
  )

  const options = filtered.map((b) => ({ label: b.libelle, value: b.id }))
  const opt = options.find((o) => selected === o.value)

  return (
    <MainContainer>
      <Animators>
        <SearchContainer>
          <TextInput
            value={search}
            onChange={setSearch}
            placeholder={i18n.t('screens.incident.ACTIVITY.search')}
            left={{ name: 'search' }}
          />
        </SearchContainer>

        <Choice data={options} onItemSelected={(opt) => onItemSelected(opt.value)} value={opt} lines={2} />
      </Animators>
    </MainContainer>
  )
}

export default Activity

const MainContainer = styled(View)`
  margin: 0 20px;
`

const SearchContainer = styled(View)`
  margin-bottom: 25px;
`
